import React from 'react';
import {ThreeDots} from 'react-loader-spinner';
import 'assets/css/componentStyles/Loader.css';

const LoaderComponent = () => {
  return (
    <div className="loader-container">
      <ThreeDots
        type="TailSpin"
        color="var(--bs-azure)"
        height={100}
        width={100}
      />
    </div>
  );
};

export default LoaderComponent;
